import promocodes from './promocodes'
import discountcodes from './discountcodes'
import codescouk from './codescouk'

import {
  CLIENT_PROMO_CODES,
  CLIENT_DISCOUNT_CODES,
  CLIENT_CODES_CO_UK,
} from './siteIds'

const APP_CONFIG = {
  [CLIENT_PROMO_CODES]: promocodes,
  [CLIENT_DISCOUNT_CODES]: discountcodes,
  [CLIENT_CODES_CO_UK]: codescouk,
}

export default APP_CONFIG
